import React from "react";

function RoomCardSkeleton({ totalCard = 9, showMenu = true }) {
  return (
    <div className="grid md:grid-cols-2 lg:grid-cols-3 3xl:grid-cols-4 grid-cols-1 gap-8 py-5">
      {new Array(totalCard).fill(0).map((_, index) => (
        <div className="" key={index}>
          <div className="rounded-xl w-full animate-pulse bg-frescoWhite dark:bg-darkGray h-40"></div>
          <div>
            <div>
              <p className="rounded-xl w-28 animate-pulse bg-frescoWhite dark:bg-darkGray h-4 mt-2"></p>
            </div>
            <div className="flex justify-between items-center">
              <p className="rounded-xl w-36 animate-pulse bg-frescoWhite dark:bg-darkGray h-4 mt-2"></p>
              {showMenu && (
                <div className="rounded-full w-6 animate-pulse bg-frescoWhite dark:bg-darkGray h-6"></div>
              )}
            </div>
          </div>
        </div>
      ))}
    </div>
  );
}

export default RoomCardSkeleton;
